// Header — institutional top bar with the digiASIA brand lockup (mockup chrome).
//
// Navy bar carrying the product wordmark on the left and the drill-down
// breadcrumb (US-878 · R-7) beside it. The "ASIA" mark is the one gold accent
// here (One Accent Rule). On mobile a menu button opens the rail/panel drawer
// (the panel isn't in the grid at that size). The far-right side (country
// dropdown · Share) is owned by US-877 / US-882 and intentionally left open.
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useTheme } from "@mui/material/styles";
import SelectionBreadcrumb from "./SelectionBreadcrumb";
import CountryDropdown from "./CountryDropdown";
import DownloadScorecardButton from "../report/DownloadScorecardButton";

const Header = ({ onMenuClick }) => {
  const { tokens } = useTheme();

  return (
    <Box
      component="header"
      data-region="header"
      sx={{
        gridArea: "header",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: tokens.spacing.md, md: tokens.spacing.lg },
        bgcolor: "primary.main",
        color: "primary.contrastText",
        boxShadow: tokens.shadows.anchor,
        position: "relative",
        zIndex: 30,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, md: 1.75 } }}>
        <IconButton
          onClick={onMenuClick}
          aria-label="Open map controls"
          edge="start"
          sx={{ display: { xs: "inline-flex", md: "none" }, color: "inherit" }}
        >
          <MenuRoundedIcon />
        </IconButton>
        <Typography
          component="span"
          sx={{ fontSize: 18, fontWeight: 700, letterSpacing: "0.01em" }}
        >
          digi
          <Box component="span" sx={{ color: "secondary.main" }}>
            ASIA
          </Box>
          <Box component="span" sx={{ fontWeight: 400, opacity: 0.88 }}>
            {" · Insights"}
          </Box>
        </Typography>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: 1.75,
          }}
        >
          <Box
            aria-hidden
            sx={{ width: "1px", height: 20, bgcolor: "rgba(255,255,255,0.28)" }}
          />
          <Typography
            component="span"
            sx={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.14em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.82)",
            }}
          >
            Connectivity Mapping Tool
          </Typography>
        </Box>
      </Box>

      {/* Drill-down path (US-878) sits left/center and takes the free space; the
          DMC selector (US-877) and the report control (US-882) anchor the far
          right — the Share/login slot reserved by US-877. */}
      <SelectionBreadcrumb />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexShrink: 0 }}>
        <CountryDropdown />
        <DownloadScorecardButton />
      </Box>
    </Box>
  );
};

export default Header;
